export default __webpack_public_path__ + "static/media/andrew.962f2c30.svg";